
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-number-input-config",
})
export default class NumberInputConfig extends ComponentConfigMixins {}
